import swal from "sweetalert";
import axiosInstance from "../api";
import { GET_DRIVER, GET_DRIVER_BY_ID } from "../constants";

export const getDriver = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/drivers/`, { params: data });
    if (response?.data?.status) {
      dispatch({ type: GET_DRIVER, driverlist: response?.data?.response });
    } else {
      dispatch({ type: GET_DRIVER, driverlist: [] });
    }
  } catch (err) {
   // console.error(err);
    dispatch({ type: GET_DRIVER, driverlist: [] });
  }
};

export const addDriver = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("admin/drivers/", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/driverlist");
      return response;
    }
    else{
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

   
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const updateDriver = (data, setLoading,navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("admin/drivers/", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/driverlist")
      return response;
    }
  else{
    swal({
      text: response?.data?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  }
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const deleteDriver = (id, setLoading, params) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`admin/drivers/${id}/`);
    if (response?.data?.status) {
      dispatch(getDriver(params));
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const getDriverById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/drivers/${id}/`);
    if (response?.data?.status) {
      dispatch({ type: GET_DRIVER_BY_ID, driverbyid: response.data.response });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
  }
};


export const addBulkdriverData = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("admin/drivers/", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      window.location.reload()
    }
    else{
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
   // console.error(err);
  } finally {
  }
};
